import { Affix, Drawer, Grid, Layout, Modal } from "antd";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Sidenav from "../Sidenav/Sidenav";
import Footer from "./Footer";
import Header from "./Header";
import styles from "./Main.module.css";
import QuickLinks from "./QuickLinks";

const { Header: AntHeader, Content, Sider } = Layout;
const { useBreakpoint } = Grid;

const cleanupOverlayArtifacts = () => {
  Modal.destroyAll();

  document.body.classList.remove("ant-scrolling-effect");
  document.body.style.removeProperty("overflow");
  document.body.style.removeProperty("overflow-x");
  document.body.style.removeProperty("overflow-y");
  document.body.style.removeProperty("width");
  document.body.style.removeProperty("padding-right");
  document.body.style.removeProperty("touch-action");

  const hasVisibleOverlayHost = Array.from(
    document.querySelectorAll(".ant-modal-wrap, .ant-drawer-content-wrapper")
  ).some((node) => {
    const style = window.getComputedStyle(node);
    return style.display !== "none" && style.visibility !== "hidden";
  });

  if (!hasVisibleOverlayHost) {
    document
      .querySelectorAll(".ant-modal-mask, .ant-drawer-mask")
      .forEach((node) => node.remove());

    document
      .querySelectorAll(".ant-modal-wrap, .ant-drawer-content-wrapper")
      .forEach((node) => node.remove());

    document
      .querySelectorAll(".ant-modal-root, .ant-drawer-root")
      .forEach((node) => {
        if (!node.querySelector(".ant-modal, .ant-drawer, .ant-modal-mask, .ant-drawer-mask")) {
          node.remove();
        }
      });
  }
};

function Main({ children }) {
  const screens = useBreakpoint();
  const [collapsed, setCollapsed] = useState(false);
  const [sideNavOpenKeys, setSideNavOpenKeys] = useState("");

  const sideNavOpenKeysHandler = (val) => {
    setSideNavOpenKeys(val);
  };

  const handleCollapsed = (val) => {
    setCollapsed(val);
  };

  const [visible, setVisible] = useState(false);
  const [placement, setPlacement] = useState("right");
  const [sidenavColor, setSidenavColor] = useState("#1890ff");
  const [sidenavType, setSidenavType] = useState("transparent");
  const [fixed, setFixed] = useState(false);

  const isDesktop = !!screens.lg;

  const openDrawer = () => setVisible((prev) => !prev);
  const handleSidenavType = (type) => setSidenavType(type);
  const handleSidenavColor = (color) => setSidenavColor(color);
  const handleFixedNavbar = (type) => setFixed(type);

  let { pathname } = useLocation();
  pathname = pathname.replace("/", " ");

  useEffect(() => {
    if (pathname === "rtl") {
      setPlacement("left");
    } else {
      setPlacement("right");
    }
  }, [pathname]);

  useEffect(() => {
    setVisible(false);
  }, [pathname, isDesktop]);

  useEffect(() => {
    cleanupOverlayArtifacts();
  }, [pathname]);

  useEffect(() => {
    cleanupOverlayArtifacts();
  }, [visible, isDesktop]);

  useEffect(() => {
    cleanupOverlayArtifacts();

    // Cold start can briefly mount antd masks after the first paint.
    const timeoutId = window.setTimeout(cleanupOverlayArtifacts, 500);

    const handleWindowFocus = () => cleanupOverlayArtifacts();
    window.addEventListener("focus", handleWindowFocus);

    return () => {
      window.clearTimeout(timeoutId);
      window.removeEventListener("focus", handleWindowFocus);
    };
  }, []);

  const isLogged = Boolean(localStorage.getItem("isLogged"));

  return (
    <Layout className={styles.mainLayout}>
      {isLogged && !isDesktop && (
        <Drawer
          title={false}
          placement={placement === "right" ? "left" : "right"}
          closable={false}
          onClose={() => setVisible(false)}
          open={visible}
          mask={false}
          afterOpenChange={(open) => {
            if (!open) {
              window.setTimeout(cleanupOverlayArtifacts, 0);
            }
          }}
          destroyOnClose
          maskClosable={false}
          key={placement === "right" ? "left" : "right"}
          width={220}
        >
          <Layout>
            <Sider
              trigger={null}
              width={220}
              theme="light"
              className={styles.siderDrawer}
            >
              <Sidenav color={sidenavColor} sideNavOpenKeys={sideNavOpenKeys} />
            </Sider>
          </Layout>
        </Drawer>
      )}
      {isLogged && (
        <Sider
          breakpoint="lg"
          trigger={null}
          collapsible
          collapsed={collapsed}
          width={220}
          theme="light"
          className={styles.siderMain}
        >
          {collapsed ? (
            ""
          ) : (
            <div>
              <h3 className="text-white ms-5 mt-2 mb-1 ">
              Dabba{" "}
              <strong style={{ color: "#be3976	", fontWeight: "bold" }}>
                ERP
              </strong>
              </h3>
            </div>
          )}
          {isLogged && (
            <Sidenav color={sidenavColor} sideNavOpenKeys={sideNavOpenKeys} />
          )}
        </Sider>
      )}
      <Layout
        className={
          isLogged
            ? collapsed
              ? styles.mainLayoutUncollapse
              : styles.mainLayoutCollapse
            : styles.mainLayoutMarginLeftZero
        }
      >
        {fixed ? (
          <Affix>
            <AntHeader>
              <Header
                onPress={openDrawer}
                name={pathname}
                subName={pathname}
                handleSidenavColor={handleSidenavColor}
                handleSidenavType={handleSidenavType}
                handleFixedNavbar={handleFixedNavbar}
                collapsed={collapsed}
                handleCollapsed={handleCollapsed}
                isLogged={isLogged}
              />
            </AntHeader>
          </Affix>
        ) : (
          <AntHeader>
            <Header
              onPress={openDrawer}
              name={pathname}
              subName={pathname}
              handleSidenavColor={handleSidenavColor}
              handleSidenavType={handleSidenavType}
              handleFixedNavbar={handleFixedNavbar}
              collapsed={collapsed}
              handleCollapsed={handleCollapsed}
            />
          </AntHeader>
        )}
        {isLogged &&
          (pathname.trim() === "dashboard" || pathname.trim() === "") && (
            <QuickLinks
              sideNavOpenKeys={sideNavOpenKeys}
              sideNavOpenKeysHandler={sideNavOpenKeysHandler}
            />
          )}

        <Content>{children}</Content>
        <Footer />
      </Layout>
    </Layout>
  );
}

export default Main;
